<template>
    <v-layout>
        <v-layout
            row
            wrap
            class="activity-feed"
            v-if="canViewActivityFeed">

            <v-layout
                class="activity-feed__network-team"
                row
                wrap
                v-if="($route.path.includes('/network') || $route.path.includes('/group')) &&
                        this.getIsCommunityModerated &&
                        this.getIsCommunityAdmin &&
                        !showInappropriatePosts">
                <v-flex xs12 sm8>
                    <v-flex v-if="activityList"><span v-if="currentPostType === postTypes.PENDING_MODERATION">Hi {{this.profileInformation.firstName}}, there are {{activityList.length}} items pending moderation.</span></v-flex>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-select
                        data-qe-id="post_type_select_dropdown"
                        item-text="type"
                        v-model="currentPostType"
                        :items="getPostTypes"></v-select>
                </v-flex>
            </v-layout>
            <v-flex xs12 class="activity-feed__posts">
                <transition name="fade">
                    <v-flex
                        transition="fade-transition"
                        xs12
                        class="moderated_post panelBlock"
                        v-if="this.getModeratedPostCreated && !this.getIsCommunityAdmin">
                        <v-flex class="moderated_post_text">
                            {{communityCommonConstant.post.MODERATED_POST_MESSAGE}}
                        </v-flex>
                    </v-flex>
                </transition>
                <div v-if="isAdminPageFeed">
                    <component
                            v-cloak
                            v-for="activity in activityList"
                            :key="activity.id"
                            :data-qe-id="'post_div_' + activity.id"
                            :is="componentTypeFor(activity)"
                            v-bind="componentPropsFor(activity)">
                    </component>
                    <status-overlay
                            :action="loadPostsAction"
                            content-height="240px"
                            background-color="transparent">
                    </status-overlay>
                </div>
                <div v-infinite-scroll="getActivity" :infinite-scroll-distance="2000" v-else>
                    <component
                        v-cloak
                        v-for="activity in activityList"
                        :key="activity.id"
                        :data-qe-id="'post_div_' + activity.id"
                        :is="componentTypeFor(activity)"
                        v-bind="componentPropsFor(activity)">
                    </component>
                    <status-overlay
                        :action="loadPostsAction"
                        content-height="240px"
                        background-color="transparent">
                    </status-overlay>
                </div>
                <v-flex
                    xs12
                    text-xs-center
                    pa-5
                    class="no-activity-yet"
                    v-show="noActivity">
                    <span>{{communityCommonConstant.post.NO_ACTIVITY}}</span>
                </v-flex>
            </v-flex>
        </v-layout>
        <non-member-message v-else></non-member-message>
    </v-layout>
</template>

<script>
    import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
    import ActivityPost from './ActivityPost';
    import PostEditor from '../PostEditor/PostEditor';
    import HiddenPost from '../HiddenPost/HiddenPost';
    import AddPost from '../AddPost/AddPost';
    import NonMemberMessage from '../NonMemberMessage/NonMemberMessage';
    import StatusOverlay from '../../StatusOverlay/StatusOverlay';
    import { storeAction } from '../../../store/storeActions.constant';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { communityCommonConstant } from '../communityCommon.constant';
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { postTypes, routerNames } from "../../appCommon.constants";
    import { getRandomId } from "../../../common/utils/utils";
    import { myToolsConstants } from '../../Tools/mytools.constant';

    export default {
        name: 'ActivityFeed',
        created() {
            this.resetActivityFeedList();
            this.moderatedPostCreatedMut();
            this.currentPostType = this.postTypes.ALL_POSTS;
        },
        components: {
            ActivityPost,
            PostEditor,
            HiddenPost,
            AddPost,
            NonMemberMessage,
            StatusOverlay,
        },
        data: () => {
            return {
                communityCommonConstant,
                forumError: null,
                postTypes,
                initiateInfiniteScrollCallBack: true,
            };
        },
        props: {
            feedList: {
                type: Array,
            },
            isAdminPageFeed: {
                type: Boolean,
            },
            listLoading: {
                type: Object,
                default: null,
            },
            canViewActivityFeed: {
                type: Boolean,
                required: false,
                default: true,
            },
            showInappropriatePosts: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            ...mapActions({
                getActivityFeedList: `chapter/${storeAction.getChapterActivityList}`,
                getCommunityById: `chapter/${storeAction.getCommunityById}`,
            }),
            ...mapMutations({
                resetActivityFeedList: `chapter/${storeMutation.resetChapterActivityList}`,
                forumErrorMessageMutation: `chapter/${storeMutation.forumErrorMessage}`,
                setSelectedPostType: `network/${storeMutation.setSelectedPostType}`,
                moderatedPostCreatedMut: `chapter/${storeMutation.setModeratedPostCreated}`,
                setSelectedNetwork: `network/${storeMutation.setSelectedNetwork}`,
            }),
            getActivity() {
                if (!this.disableInfiniteScroll && !this.noMoreActivityToFetch) {
                    if (this.$route.query && this.$route.query.postId) {
                        const highlightText = this.$route.query.highlightText ? this.$route.query.highlightText : "";
                        const showAllActivityFeedCommunity = this.$route.query.showAllActivityFeedCommunity ? this.$route.query.showAllActivityFeedCommunity : "false";

                        const post = {
                            postId: this.$route.query.postId,
                            highlightText,
                            showAllActivityFeedCommunity,
                        };

                        this.getActivityFeedList(post);
                    } else {
                        this.getActivityFeedList();
                    }
                }
            },
            getRandomId,
            componentTypeFor(activity) {
                // Disabling lint rule since this is a simple expression and operator precedence
                // is not a concern, so I think this is easy to understand as-is.

                // eslint-disable-next-line no-nested-ternary
                return this.isPostEditing(activity.id) ?
                    'PostEditor' :
                    this.isHiddenPost(activity.id) ?
                    'HiddenPost' :
                    'ActivityPost';
            },

            componentPropsFor(activity) {
                const {
                    isAdminPageFeed,
                    canEditAllActivityFeed,
                } = this;
                return this.isPostEditing(activity.id) ? {
                    post: activity,
                    allowPostImage: true,
                } : {
                    activity,
                    isAdminPageFeed,
                    canEditAllActivityFeed,
                };
            },
            resetModeratedPostMessage() {
                setTimeout(() => {
                    this.moderatedPostCreatedMut(false);
                }, 10000);
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                [storeGetters.activityFeedList]: `chapter/${storeGetters.activityFeedList}`,
                [storeGetters.disableInfiniteScroll]: `chapter/${storeGetters.disableInfiniteScroll}`,
                [storeGetters.noMoreActivityToFetch]: `chapter/${storeGetters.noMoreActivityToFetch}`,
                [storeGetters.isPostEditing]: `chapter/${storeGetters.isPostEditing}`,
                [storeGetters.isHiddenPost]: `chapter/${storeGetters.isHiddenPost}`,
                [storeGetters.getIsCommunityAdmin]: `chapter/${storeGetters.getIsCommunityAdmin}`,
                [storeGetters.getModeratedPostCreated]: `chapter/${storeGetters.getModeratedPostCreated}`,
                [storeGetters.getIsCommunityModerated]: `chapter/${storeGetters.getIsCommunityModerated}`,
                selectedPostType: `network/${storeGetters.getSelectedPostType}`,
                selectedNetwork: `network/${storeGetters.getSelectedNetwork}`,
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
                [storeGetters.usersCommunitiesList]: `chapter/${storeGetters.usersCommunitiesList}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,

            }),
            canEditAllActivityFeed() {
                return (this.$route.name && this.$route.name.toLowerCase() === routerNames.HOME.toLowerCase())
                    || (
                        this.communityInfo
                        && this.communityInfo.communityId === this.$route.params.communityId
                        && this.communityInfo.userAccess
                        && this.communityInfo.userAccess.canSharePost
                    );
            },
            loadPostsAction() {
                return this.listLoading ? this.listLoading : this.actions[storeAction.getChapterActivityList];
            },
            isModeratedNetwork() {
                const community = this.usersCommunitiesList && this.selectedNetwork &&
                    this.usersCommunitiesList.find(o => o.communityId === this.selectedNetwork.communityId);
                return !!(community && community.isActivityModerated);
            },
            isAllNetworks() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE);
            },
            activityList() {
                if (this.getModeratedPostCreated) {
                    this.resetModeratedPostMessage();
                }
                const list = this.feedList ? this.feedList : this.activityFeedList;
                if (list) {
                    if (this.showInappropriatePosts) {
                        return list.filter((i) => {
                            return i.hasBeenMarkedInappropriate || i.inappropriateChildren > 0 || i.inappropriateGrandChildren > 0;
                        });
                    }
                    if (((this.isModeratedNetwork || this.getModeratedPostCreated || this.isAllNetworks) && !this.getIsCommunityAdmin) ||
                        (this.getIsCommunityAdmin && this.currentPostType === this.postTypes.ALL_POSTS)) {
                        return list.filter((i) => {
                            return !i.isPendingModeration;
                        });
                    }
                    if (this.selectedPostType === this.postTypes.PENDING_MODERATION && this.getIsCommunityAdmin) {
                        return list.filter(i => i.isPendingModeration);
                    }
                }
                this.setSelectedNetwork(null);
                return list && list.filter(activity => !!(activity.body || (activity.postImage && activity.postImage.length > 0 && activity.postImage[0].url) || (activity.postAttachment && activity.postAttachment.length > 0 && activity.postAttachment[0].url)));
            },
            noActivity() {
                return this.activityList && this.activityList.length === 0 &&
                    !this.loadPostsAction.pending && !this.loadPostsAction.failed;
            },
            getPostTypes() {
                const postType = this.postTypes;
                return Object.keys(postType).map((key, i) => {
                    return { id: i, type: postType[key] };
                });
            },
            currentPostType: {
                get() {
                    return this.selectedPostType;
                },
                set(val) {
                    this.setSelectedPostType(val);
                },
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .activity-feed__posts {
        position: relative;
        min-height: 240px;
    }

    .no-activity-yet {
        color: $ypo-title-blue-gray;
        background-color: $white;
        font-size: 28px;
        letter-spacing: -0.17px;
        line-height: 38px;
    }

    .moderated_post {
        background-color: $ypo-blue-grey;
        height: 50px;
        vertical-align: middle;

    }

    .moderated_post_text {
        margin: 12px;
    }

    .non_member_error_message {
        color: $black;
        background-color: $white;
        font-size: 14px;
        letter-spacing: -0.17px;
        line-height: 38px;
    }
</style><style lang="scss">
    @import '../../../common/styles/_colors.scss';

    .activity-feed {
        &__network-team {
            align-items: center;

            span {
                padding-left: 5px;
            }

            .v-select__selection {
                font-weight: 600;
                font-size: 14px;
            }
        }
    }
</style>
